import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import companyEsCL from './locales/es-CL.json';
import companyEnUS from './locales/en-US.json';
import companyPtBR from './locales/pt-BR.json';

export const companyI18n = buildScopedI18n({
  esCL: companyEsCL,
  enUS: companyEnUS,
  ptBR: companyPtBR,
});
